import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  Box,
  Center,
  Text
} from '@chakra-ui/react'
import { FC } from 'react'

import useParametrizationCurveExecutation from '@hook/parametrization/use-curve-executation'

const ParametrizationCurveExecutationModalDelete: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { deleteData } = useParametrizationCurveExecutation()

  return (
    <>
      <Button
        fontSize={14}
        size="sm"
        colorScheme="red"
        variant="outline"
        transition="all ease .2s"
        onClick={onOpen}
      >
        Excluir
      </Button>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody bg="white" pt={0} py={4}>
            <Box p={6}>
              <Text fontSize="3xl" align="center">
                Confirmar exclusão
              </Text>
              <Text align="center" fontSize="sm">
                Tem certeza de que deseja excluir? Esta ação não pode ser
                desfeita.
              </Text>
            </Box>
            <Center>
              <Box p={2} alignItems="center" alignContent="center">
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={() => {
                    deleteData()
                    onClose()
                  }}
                  alignItems="center"
                >
                  Sim
                </Button>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Não
                </Button>
              </Box>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationCurveExecutationModalDelete
